/**
 *
 * Header
 *
 */
import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { Notifications } from './Notifications';
import { NotificationItem, NotificationPagination } from 'types/Notification';
import { AddNewAppointmentRequest } from 'app/pages/appointment-copy/components/AddNewAppointmentRequest';
import { AddNewProviderReferral } from 'app/pages/referral-list/components/AddNewProviderReferral';

import { Input } from 'app/components/ui/input';

interface Props {
  onSearch?: (value: string) => void;
  notifications: NotificationItem[];
  onNotificationSelect?: (entityId: string | null) => void;
  onNotificationRead?: () => void;
  notificationPagination?: NotificationPagination;
  onLoadMoreNotifications?: () => void;
  notificationHasMore?: boolean;
  isLoadingMoreNotifications?: boolean;
  paddingBottom?: string;
}

const routeHeadings = [
  {
    path: ['/', '/appointment-requests'],
    title: 'Appointment Requests',
  },
  {
    path: '/provider-referrals',
    title: 'Provider Referrals',
  },
  {
    path: '/insight-overview',
    title: 'Insight Overview',
  },
  {
    path: ['/help-center/report-issue', '/help-center/feedbacks', '/help-center/other-help'],
    title: 'Help Center',
  },
  {
    path: ['/account-settings/user-profile', '/account-settings/practice-info', '/account-settings/service-plans', '/account-settings/billing-history'],
    title: 'Account Settings',
  },
];

export const Header = memo((props: Props) => {
  const { 
    onSearch, 
    notifications, 
    onNotificationSelect,
    onNotificationRead,
    notificationPagination,
    onLoadMoreNotifications,
    notificationHasMore,
    isLoadingMoreNotifications,
    paddingBottom
  } = props;
  const location = useLocation();
 
  // Find the matching route or use the first one as default
  const currentRoute = routeHeadings.find(route => 
    Array.isArray(route.path)
      ? route.path.includes(location.pathname)
      : route.path === location.pathname,
  ) ?? { title: 'Loop Celestial' };

  return (
    <div className="fixed z-10 bg-[#F2F4F8] w-[calc(100vw-(var(--sidebar-width)))] h-[6.5rem] px-6">
      <div className={`flex items-center justify-between gap-6 py-8 ${paddingBottom} border-b border-[#E5E7EB] overflow-x-auto [&::-webkit-scrollbar]:hidden`}>
        <h1 className="font-serif text-[#5B73F1] text-2xl font-bold leading-normal tracking-[0.03rem] whitespace-nowrap">
          {currentRoute.title}
        </h1>
        <div className="flex gap-5 items-center">
          {['Appointment Requests', 'Provider Referrals'].includes(currentRoute.title) && (
            <div className="relative flex-shrink-0 w-[19.625rem]">
              <Input
                type="text"
                className="w-full h-10 py-2 pl-11 pr-3 bg-transparent border border-[#A2A9B0] rounded-lg text-black/80 placeholder:text-[#A2A9B0] text-sm font-normal leading-[1.225rem] focus-visible:outline-none focus:ring-1 focus:ring-blue-200"
                onChange={(e) => onSearch?.(e.target.value)}
                placeholder="Search by Name"
                aria-label="Search by Name"
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <img src="/images/search.svg" alt="Search" className="size-6" />
              </span>
            </div>
          )}
          {currentRoute.title === 'Appointment Requests' && (
            <AddNewAppointmentRequest onSave={() => { }} />
          )}
          {currentRoute.title === 'Provider Referrals' && (
            <AddNewProviderReferral onSave={() => { }} />
          )}
          <div className="flex-shrink-0">
            <Notifications
              notifications={
                currentRoute.title !== 'Help Center' && currentRoute.title !== 'Account Settings'
                  ? notifications : []
              }
              onNotificationSelect={onNotificationSelect}
              onNotificationRead={onNotificationRead}
              pagination={notificationPagination}
              onLoadMore={onLoadMoreNotifications}
              hasMore={notificationHasMore}
              isLoadingMore={isLoadingMoreNotifications}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
